// ----------------------------------------------------------------------

const account = {
  displayName: 'User',
  email: 'xt4566@rimac.com.pe',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
